const appDetails = {
    webLink: "https://crookedcreek.graindiscovery.com",
    googlePlayLink: "https://play.google.com/store/apps/details?id=com.graindiscovery.marketplace_flutter.crookedcreekacres",
    appStoreLink: "https://apps.apple.com/us/app/crooked-creek-acres/id1588163083?uo=4",
    landingPage: "cashbids",
    signUpButton: true
}

export default appDetails;